/**
 * RIM — Retail IRA Management module entry.
 * Plan-centric view; beneficiaries via TaxPlnBenfAdd; RMD factors from config.
 */
import './styles/rim.css';
import { RimRoutes } from './routes';

export default function RIM(): JSX.Element {
  return <RimRoutes />;
}
